import { render, staticRenderFns } from "./BulkDossierDownloadButton.vue?vue&type=template&id=cffdfdc8&scoped=true"
import script from "./BulkDossierDownloadButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./BulkDossierDownloadButton.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cffdfdc8",
  null
  
)

export default component.exports